import SubscriptionCancelled from './SubscriptionCancelled';
export default SubscriptionCancelled;